import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Tooltip from 'material-ui/Tooltip';
import IconButton from 'material-ui/IconButton';
import Letter from '../../../../Icons/Letter';
import ListIcon from '../../../../Icons/ListIcon';
import Download from '../../../../Icons/Download';
import { isEnabledUserRole } from '../../../../../utils/utils';
import { isEnableFunction } from '../../../../../utils/componentUtils';
import { isEnableSendOneLetter } from '../../../../../utils/userOptionUtils';
import { isEnabledExportExecutiveList, isEnabledSendLetter } from '../../../../../utils/planUtils';

const styles = () => ({
  root: {
    display: 'flex',
    margin: 'auto 0',
    textAlign: 'end',
  },

  tooltip: {
    fontWeight: 200,
    fontSize: 13,
    maxWidth: 340,
    backgroundColor:"#181819",
    padding: '12px 15px',
    opacity: 1,
  },

  iconBtn: {
    minWidth: 'unset',
    minHeight: 'unset',
    width: 33,
    height: 33,
    marginLeft: '10px',
    borderRadius: 0,
    border: '1px solid #E7E9EB',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.2)',
    }
  },

  disabledButton: {
    minWidth: 'unset',
    minHeight: 'unset',
    width: 33,
    height: 33,
    marginLeft: '10px',
    borderRadius: 0,
    border: '1px solid #E7E9EB',
    background: '#ECEDEF',
  },

  icon: {
    width: '33px',
    height: '33px',
    marginRight: '10px',
    background: '#040E35',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    border: '1px solid #E7E9EB',
  },

  inline: {
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
  },

  vertical: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
});

class FunctionButtons extends React.Component {
  render () {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        {(isEnableFunction(this.props, "toggleEditTagsDialog")) &&
          <Tooltip
            placement="bottom"
            title="リストに追加 / 削除"
            classes={{
              tooltip: classes.tooltip,
            }}
          >
            <div>
              <IconButton
                id="function-buttons-edit-tags"
                className={isEnabledUserRole(this.props.user, "executive-list", "edit-tag") ? classes.iconBtn : classes.disabledButton}
                color="default"
                onClick={()=> {
                  this.props.toggleDialog();
                  this.props.toggleEditTagsDialog();
                }}
                disabled={!isEnabledUserRole(this.props.user, "executive-list", "edit-tag")}
              >
                <ListIcon width={24} height={24} color="#FFFFFF"/>
              </IconButton>
            </div>
          </Tooltip>
        }
        {(isEnableFunction(this.props, "toggleCsvDownloadDialog") && (this.props.enableExecutiveListAdvancedSearch || isEnabledExportExecutiveList(this.props.user))) &&
          <Tooltip
            placement="bottom"
            title="CSVダウンロード"
            classes={{
              tooltip: classes.tooltip,
            }}
          >
            <div>
              <IconButton
                id="function-buttons-csv-download"
                className={isEnabledUserRole(this.props.user, "executive-list", "download-list") ? classes.iconBtn : classes.disabledButton}
                color="default"
                onClick={() =>{
                  this.props.toggleDialog();
                  this.props.toggleCsvDownloadDialog();
                }}
                disabled={!isEnabledUserRole(this.props.user, "executive-list", "download-list")}
              >
                <Download width={20} height={20} color="#5A5B62" />
              </IconButton>
            </div>
          </Tooltip>
        }
        {(isEnableFunction(this.props, "goToSendLetter") && isEnabledSendLetter(this.props.user) && isEnableSendOneLetter(this.props.user)) &&
          <Tooltip
            placement="bottom"
            title="レター送付"
            classes={{
              tooltip: classes.tooltip,
            }}
          >
            <div>
              <IconButton
                id="function-buttons-order-letter"
                className={isEnabledUserRole(this.props.user, "executive-list", "order-letter") ? classes.iconBtn : classes.disabledButton}
                color="default"
                onClick={this.props.goToSendLetter}
                disabled={!isEnabledUserRole(this.props.user, "executive-list", "order-letter")}
              >
                <Letter width={24} height={24} color="#FFFFFF"/>
              </IconButton>
            </div>
          </Tooltip>
        }
      </div>
    );
  }
}

FunctionButtons.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  enableExecutiveListAdvancedSearch: PropTypes.bool,
  toggleDialog: PropTypes.func,
  toggleEditTagsDialog: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  toggleCsvDownloadDialog: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  goToSendLetter: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
}

PropTypes.defaultValue = {
  toggleDialog: null,
  toggleEditTagsDialog: null,
  toggleCsvDownloadDialog: null,
  goToSendLetter: null,
}

export default withStyles(styles)(FunctionButtons);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/parts/FunctionButtons.jsx